import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../../../core/services/shared.service';
import Swal from 'sweetalert2';

import { MultiSelect } from '@syncfusion/ej2-dropdowns';
import { EventSettingsModel } from '@syncfusion/ej2-angular-schedule';

interface FilterKey {
  Code: string;
}

let defaultData: Object[] = [
  {
      Id: 1,
      Subject: 'Conference',
      StartTime: new Date(2024, 11, 7, 10, 0),
      EndTime: new Date(2024, 11, 7, 11, 0),
      IsAllDay: false
  }, {
      Id: 2,
      Subject: 'Meeting - 1',
      StartTime: new Date(2024, 11, 15, 10, 0),
      EndTime: new Date(2024, 11, 16, 12, 30),
      IsAllDay: false
  }, {
      Id: 3,
      Subject: 'Paris',
      StartTime: new Date(2024, 11, 13, 12, 0),
      EndTime: new Date(2024, 11, 13, 12, 30),
      IsAllDay: false
  }, {
      Id: 4,
      Subject: 'Vacation',
      StartTime: new Date(2024, 11, 12, 10, 0),
      EndTime: new Date(2024, 11, 12, 10, 30),
      IsAllDay: false
  }
];

@Component({
  selector: 'app-lista-cards',
  templateUrl: './lista-cards.component.html',
  styleUrl: './lista-cards.component.scss',
})

export class ListaCardsComponent implements OnInit {
  @Input() WsURL: string = '';
  @Input() WsLlaves: any = '';
  @Input() WORKFLOW: any;                  // almora 2023.07.01 Información de Workflow
  @Input() DOC10ARC: any;                  // almora 2023.07.05 Información de Cejilla Documentos
  @Input() PRO10ARC: any;                  // almora 2024.01.31 Información de Cejilla Gantt Proyectos
  @Input() SYS02CON_PAPA_LD: string;       // almora 2024.06.19 Guardo SYS02CON de la tabla principal, se carga si soy Lista Detalle desde Wizard
  @Input() interno: boolean = false;

  @Output() evtCerrarInterno = new EventEmitter<string>();

  cards: any[] = [];
  grupos: any[] = [];
  cards2: any[] = [];
  operaciones: any[] = [];
  cardInternos = false;
  llavesInternas = [];
  urlInterna = '';

  multiselectComp: MultiSelect;

  card: NodeList;
  cardEle: HTMLElement;
  data: Object[] = [];
  multiSelectData: Object[] = [];
  searchData: Object[] = [];
  searchValCount: number = 0;
  emptyData: boolean = true;
  filteredCards: any[] = [];

  selectedCardIndex: number | null = null;
  selectedCardIndexInfo: number | null = null;
  selectedCardIndexCalendar: number | null = null;

  // para calendario
  public selectedDate: Date = new Date(2024, 11, 13);
  public showWeekend: boolean = false;
  public eventSettings: EventSettingsModel = { dataSource: defaultData };

  constructor(private dataService: SharedService) {}

  openIndex: number | null = null;
  cliente : any = "";

  toggleCard(index: number) {
    this.openIndex = this.openIndex === index ? null : index;
  }

  public DataList: any = [];

  ngOnInit() {
    this._fetchData();
    this.cliente = localStorage.getItem('CLITUT');
  }

  _fetchData(filtros?: any) {

    if (this.WsLlaves == null || this.WsLlaves == "")
      this.WsLlaves = [];

    let objFiltros = JSON.parse("{   \"FILTROS_OPCIONALES\"   : [{}]" +
      (this.WORKFLOW != null ? (", \"WORKFLOW\" : " + JSON.stringify(this.WORKFLOW)) : "") +
      (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
      (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "") +
      ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) + "}");

    this.dataService.ConsultarWS(this.WsURL, objFiltros).subscribe(
      {
        next: (datosResp: any) => {
          this.cards = datosResp.DATA;
          this.filteredCards = this.cards;
          this.operaciones = datosResp.Operaciones;
        },
        error: (e) => {
          Swal.fire({
            html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              '</div>' +
              ' <div class="col-8">' +
              '<h3>Error</h3><br>' +
              ' <p>' + e + '</p>' +
              ' </div> ',
          });
        }
      }
    );
  }

  filterCardsByName(materiaName: string) {
    this.filteredCards = this.cards.filter((card: any) =>
      card.M11DES.toLowerCase().includes(materiaName.toLowerCase())
    );
  }

  ejecutarOperacion(operacion, card) {
    if (operacion.Evento == 'ABRIR_MS') {
      this.llavesInternas = card.Llaves;
      this.urlInterna = operacion.URL;
      this.cardInternos = true;
    } else {
      let peticion = { FILTROS_OBLIGATORIOS: this.WsLlaves, FILTROS_OPCIONALES: [{}], Llaves: card.Llaves };
      this.dataService.ConsultarWS(operacion.URL, JSON.stringify(peticion)).subscribe(
        {
          next: (datosResp: any) => {
            Swal.fire({
              position: "bottom-end",
              toast: true,
              icon: "success",
              text: "OK",
              showConfirmButton: false,
              timer: 5000,
            });
            this._fetchData();
          },
          error: (e) => {
            Swal.fire({
              html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-4">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                '</div>' +
                ' <div class="col-8">' +
                '<h3>Error</h3><br>' +
                ' <p>' + e + '</p>' +
                ' </div> ',
            });
          }
        }
      );
    }

  }

  operacionInterna(operacion, card) {
    let peticion = { FILTROS_OBLIGATORIOS: this.WsLlaves, FILTROS_OPCIONALES: [{}], Llaves: card.Llaves };
    this.dataService.ConsultarWS(operacion.URL, JSON.stringify(peticion)).subscribe(
      {
        next: (datosResp: any) => {
          Swal.fire({
            position: "bottom-end",
            toast: true,
            icon: "success",
            text: "OK",
            showConfirmButton: false,
            timer: 5000,
          });
        },
        error: (e) => {
          Swal.fire({
            html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              '</div>' +
              ' <div class="col-8">' +
              '<h3>Error</h3><br>' +
              ' <p>' + e + '</p>' +
              ' </div> ',
          });
        },
        complete: () => {
          this.evtCerrarInterno.emit('card');
        }
      }
    );
  }

  cerrarInterno(card) {
    this.cardInternos = false;
    this._fetchData();
  }

  volver() {
    this.evtCerrarInterno.emit('card');
  }

  prematricula(M11COD: any, M23GRU: any, M44MAT: any, EQUIVALENTE: any, index: any, isGeneral: boolean) {
    if (this.WsLlaves == null || this.WsLlaves == "") {
      this.WsLlaves = [];
    }

    let wsLlaves = [];
    if (EQUIVALENTE =="S")
		  // Materia equivalente, se invierten los códigos M11COD<->M44MAT 
	    wsLlaves = [{ M11COD: M44MAT, M23GRU: M23GRU, M44MAT: M11COD, E43MAT: ''}];
  	else if (isGeneral) 
      // Materia General, se envía en E43MAT
      wsLlaves = [{ M11COD: M11COD, M23GRU: M23GRU, M44MAT: '', E43MAT: M44MAT }];      
  	else
      // Materia Normal 
	    wsLlaves = [{ M11COD: M11COD, M23GRU: M23GRU, M44MAT: '', E43MAT: '' }];
  
  console.log(wsLlaves);
  
    // Construir objFiltros
    let objFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\" : [{}]" +
      (this.WORKFLOW != null ? (", \"WORKFLOW\" : " + JSON.stringify(this.WORKFLOW)) : "") +
      (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
      (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "") +
      ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) + ", \"LLAVES\" : " + JSON.stringify(wsLlaves) + "}");
  
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¿Deseas matricularte a la materia y grupo seleccionado?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, Matricularme',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
  
          this.dataService.ConsultarWS('api/ws/mam/M31ARC_WS/Prematricular/ldMAM_Prematricula', objFiltros).subscribe(
            (datosResp: any) => {
              Swal.fire({
                icon: 'success',
                title: 'Matrícula exitosa',
                text: '¡Ya quedaste matriculado!',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false 
              }).then((result) => {
                if (result.isConfirmed) {
                  this._fetchData();
                  this.toggleSidebar(index);
                }
              });
            },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else {
          console.log('El usuario canceló el envío.');
        }
      });
  }  

  eliminarPrematricula(M11COD: any, E43MAT : any = '', M44MAT: any, M11GEN : any, M23GRU: any, index:any, EQUIVALENTE: any) {
    if (this.WsLlaves == null || this.WsLlaves == "") {
      this.WsLlaves = [];
    }

    let wsLlaves = [];
    wsLlaves = [{ M11COD: M11COD, M23GRU: M23GRU, M44MAT : M44MAT, M11GEN : M11GEN, E43MAT : E43MAT, EQUIVALENTE : EQUIVALENTE }];
  
    // Construir objFiltros
    let objFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\" : [{}]" +
      (this.WORKFLOW != null ? (", \"WORKFLOW\" : " + JSON.stringify(this.WORKFLOW)) : "") +
      (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
      (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "") +
      ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) + ", \"LLAVES\" : " + JSON.stringify(wsLlaves) + "}");
  
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¿Deseas eliminar la matrícula de la materia y grupo seleccionado?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
  
          this.dataService.ConsultarWS('api/ws/mam/M31ARC_WS/EliminarPrematricula/ldMAM_Prematricula', objFiltros).subscribe(
            (datosResp: any) => {
              Swal.fire({
                icon: 'success',
                title: 'Matrícula eliminada exitosamente',
                text: '¡Ya quedaste desvinculado de la materia y grupo seleccionado!',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false 
              }).then((result) => {
                if (result.isConfirmed) {
                  this._fetchData();
                  this.toggleSidebar(index);
                }
              });
            },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
            }
          );
        } else {
          console.log('El usuario canceló el envío.');
        }
      });
  } 

  toggleSidebar(index: number) {
    this.selectedCardIndex = this.selectedCardIndex === index ? null : index;
  }

  toggleSidebarInfo(index: number) {
    this.selectedCardIndexInfo = this.selectedCardIndexInfo === index ? null : index;
  }

  toggleSidebarCalendar(index: number) {
    this.selectedCardIndexCalendar = this.selectedCardIndexCalendar === index ? null : index;
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
  
  tooltipText: string | null = null;
  tooltipStyle: { [key: string]: string } = {};
  
  showTooltip(event: MouseEvent, text: string) {
    this.tooltipText = text;
    this.tooltipStyle = {
        display: 'block', // Mostrar el tooltip
        top: `${event.clientY + 10}px`,
        left: `${event.clientX + 10}px`,
    };
  }

  hideTooltip() {
      this.tooltipText = null;
      this.tooltipStyle.display = 'none'; // Ocultar el tooltip
  }

  gruposAutorizados(M11COD: any, FAC59COD: any, M12CAR: any, index: number) {
    if (this.WsLlaves == null || this.WsLlaves == "") {
      this.WsLlaves = [];
    }

    let wsLlaves = [];
    wsLlaves = [{ FAC59COD: FAC59COD, M11COD: M11COD, M12CAR:M12CAR }];
  
    // Construir objFiltros
    let objFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\" : [{}]" +
      (this.WORKFLOW != null ? (", \"WORKFLOW\" : " + JSON.stringify(this.WORKFLOW)) : "") +
      (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
      (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "") +
      ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) + ", \"LLAVES\" : " + JSON.stringify(wsLlaves) + "}");
  
      this.dataService.ConsultarWS('api/ws/mam/M31ARC_WS/ListarGruposAutorizadas', objFiltros).subscribe(
        (datosResp: any) => {
          console.log(datosResp);
          this.grupos = datosResp.DATA;
          if(this.validarGrupos()){
          	this.toggleSidebar(index);
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
  } 

  validarGrupos(){
    if(this.grupos.length == 0){
      Swal.fire({
        html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
          '<div class="col-4">' +
          ' <img src="assets/images/imageerror.png"> </img>' +
          '</div>' +
          ' <div class="col-8">' +
          '<h3>Error</h3><br>' +
          ' <p>La materia no cuenta con grupos asignados.</p>' +
          ' </div> ',
      });
      
      return false;
    }else{
      return true;
    }
  }

}
